import dayjs from 'dayjs'

// "to" в диапазоне часов хранится как начало часа, следующего за последним
// выбранным (HH:00) - для отображения включительной границы (HH:59) вычитаем минуту
export const getDisplayRangeEnd = (to: Date) =>
  dayjs(to).subtract(1, 'minute').toDate()
